import { TiVoTargets } from "hooks/tivoApps";

import { TEXTS } from "./constants";

export function getSummary(
  targets: TiVoTargets | undefined,
  getDeviceLabel: (id: string) => string
) {
  if (!targets) {
    return TEXTS.NO_TARGET;
  }
  const levels: [string[] | undefined, number, string][] = [
    [targets.platforms, targets.platforms?.length || 0, TEXTS.PLATFORMS],
    [targets.oems, targets.oems?.length || 0, TEXTS.OEMS],
    [targets.clientTypes, targets.clientTypes?.length || 0, TEXTS.CLIENT_TYPES],
  ];
  const levelIdx = levels.findLastIndex(([, count]) => count > 0);
  if (levelIdx < 0) {
    return TEXTS.ALL_PLATFORMS;
  }
  if (levels.slice(0, levelIdx).some(([, count]) => count > 1)) {
    return TEXTS.COMPLEX_TARGET;
  }
  const [ids, , prefix] = levels[levelIdx];
  const labels = (ids || []).map((id) => getDeviceLabel(id));
  return prefix + labels.join(", ");
}
